/**
 * Upstream fails silently at three points on the boot path, and §5.4 requires all
 * three to fail loudly instead. But a throwing preRegistration is itself
 * swallowed per extension (ExtensionManager.ts:239-241, `catch { console.error }`),
 * which boots the app half-registered and quiet. Re-raising on the global error
 * channel escapes that catch: it surfaces as an uncaught error, trips the dev
 * server overlay, and is reachable by monitoring.
 *
 * Shared rather than local to index.tsx because config/roots.ts needs the same
 * escape. getAuthRoot/getLoginUrl are reached from inside preRegistration — Task 6
 * awaits verifySession() there, which is why preRegistration is async — so a plain
 * `throw` from them lands in that same swallowing catch.
 */
export function fatal(message: string): never {
  const error = new Error(`[sycai] ${message}`);

  if (typeof globalThis.reportError === 'function') {
    globalThis.reportError(error);
  } else {
    setTimeout(() => {
      throw error;
    }, 0);
  }

  throw error;
}
